import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  class: "data-settings",
  style: {"max-width":"520px"}
}
const _hoisted_3 = { class: "data-field" }
const _hoisted_4 = { class: "data-field" }
const _hoisted_5 = { class: "data-field" }
const _hoisted_6 = {
  key: 0,
  class: "data-error"
}
const _hoisted_7 = {
  key: 1,
  class: "data-success"
}
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "data-title" }, "Enviar Anúncio", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("label", null, "Tipo", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.annType) = $event)),
          class: "data-select"
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("option", { value: "info" }, "Info", -1),
          _createElementVNode("option", { value: "aviso" }, "Aviso", -1),
          _createElementVNode("option", { value: "urgente" }, "Urgente", -1)
        ]))], 512), [
          [_vModelSelect, $setup.annType]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("label", null, "Título", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.annTitle) = $event)),
          type: "text",
          placeholder: "Título do anúncio"
        }, null, 512), [
          [_vModelText, $setup.annTitle]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("label", null, "Mensagem", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.annMessage) = $event)),
          rows: "4",
          style: {"padding":"10px","border":"1.5px solid #d1d5db","border-radius":"8px","font-size":"14px","resize":"vertical","outline":"none","font-family":"inherit"},
          placeholder: "Texto do anúncio..."
        }, null, 512), [
          [_vModelText, $setup.annMessage]
        ])
      ]),
      ($setup.annError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.annError), 1))
        : _createCommentVNode("", true),
      ($setup.annSuccess)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($setup.annSuccess), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "btn-admin-primary",
        type: "button",
        disabled: $setup.annSending,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.sendAnnouncement && $setup.sendAnnouncement(...args)))
      }, _toDisplayString($setup.annSending ? 'Enviando...' : 'Enviar anúncio'), 9, _hoisted_8)
    ])
  ]))
}